let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6rA6w")).then(() => parcelRequire('c3Oit'));